import {
	useStarterDashboardV2PageData,
	useStarterDashboardV2PageFcm,
} from 'src/app/pages/starterDashboardV2/pageContext';

import { NOTIFICATION_TYPES } from '../../../constants';

type UseDecisionMakerRecommendationReturn =
	| { type: (typeof NOTIFICATION_TYPES)['decisionMakerRecommendation'] }
	| undefined;
export function useDecisionMakerRecommendation(): UseDecisionMakerRecommendationReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();
	const fcm = useStarterDashboardV2PageFcm();

	// ALERTS: comment this line
	// if fcm is disabled, hide the notification
	if (!fcm.starterDashboardDMRecommenderEnabled) return undefined;

	// ALERTS: comment this line
	// if petition has a decision maker, hide the notification
	if (petition.decisionMakersConnection.totalCount !== 0) return undefined;

	// ALERTS: comment this line
	// if petition has no recommended decision makers, hide the notification
	if (petition.recommendedDecisionMakers.length === 0) return undefined;

	return { type: NOTIFICATION_TYPES.decisionMakerRecommendation };
}
